import axios from 'axios'
import { useMutation } from 'react-query'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import {AuthToken, loginUser, setAllowEventRefresh, setTerms} from '../../../slices/authSlice'

export const parseJwt = (token) => {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export const useLoginMutation = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  return useMutation(
    (body: any) => {
      return axios.post(`/login`, body)
    },
    {
      onSuccess: (response: any) => {
        // console.log(response)
        if (response.status === 'failure') {
          throw new Error(response.message)
        }
        // update local storage
        localStorage.setItem('tokenadmin', response.token)
        const parsedToken: AuthToken = parseJwt(response.token)
        // update redux
        dispatch(loginUser(parsedToken))
        dispatch(setAllowEventRefresh(response.alloweventrefresh))
        if (response.terms && response.terms.length > 0) {
          dispatch(setTerms(response.terms))
          history.push('/terms')
        }
        else {
          // redirect
          history.push('/home')
        }
      }
    }
  )
}
